import request from '@/utils/request'

// 获取回款列表
export function getPaymentList(data) {
  return request({
    url: '/move/getReceivablesList',
    method: 'post',
    data
  })
}

// 获取回款详情
export function getPaymentDetail(id) {
  return request({
    url: `/payment/${id}`,
    method: 'get'
  })
}

// 创建回款
export function createPayment(data) {
  return request({
    url: '/move/addReceivables',
    method: 'post',
    data
  })
}

// 更新回款
export function updatePayment(data) {
  return request({
    url: `/move/editReceivables`,
    method: 'post',
    data
  })
}

// 删除回款
export function deletePayment(params) {
  return request({
    url: `/move/delReceivables`,
    method: 'delete',
    params
  })
}

// 提交回款审核
export function submitPayment(id) {
  return request({
    url: `/payment/${id}/submit`,
    method: 'post'
  })
}

// 审核回款
export function approvePayment(id, data) {
  return request({
    url: `/payment/${id}/approve`,
    method: 'post',
    data
  })
}

// 获取回款审批流程
export function getPaymentProcess(id) {
  return request({
    url: `/payment/${id}/process`,
    method: 'get'
  })
}

// 搜索客户
export function searchCustomers(query) {
  return request({
    url: '/move/getCusInfo',
    method: 'get',
    params: query 
  })
} 

// 获取客户商机列表
export function getCustomerOpportunities(query) {
  return request({
    url: `/move/getCusInfoBus`,
    method: 'get',
    params: query
  })
}

// 获取商机合同列表
export function getOpportunityContracts(params) {
  return request({
    url: `/move/getOpportunityContracts`,
    method: 'get',
    params
  })
} 

export function getOpportunityPayments(params) {
  return request({
    url: `/move/getBusinessRec`,
    method: 'get',
    params
  })
} 
export function withdrawPayment(){
	
}